import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Login.css";

const API_LOGIN_URL = `${process.env.REACT_APP_API_URL}/worker-login`;

export const Login = () => {
  const navigate = useNavigate();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhoneNumber(value);
    setError("");
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    console.log("📥 Worker Login Attempt Started");

    if (!phoneNumber.trim()) {
      setError("Please enter mobile number");
      return;
    }

    if (phoneNumber.length !== 10) {
      setError("Mobile number must be 10 digits");
      return;
    }

    try {
      setLoading(true);
      setError("");

      console.log("📡 Sending login request...");

      const response = await axios.post(API_LOGIN_URL, {
        phoneNumber,
      });

      const result = response.data;

      console.log("📊 Login Response:", result);

      if (!result.success) {
        throw new Error(result.message || "Login failed");
      }

      // Save Worker Data
      localStorage.setItem(
        "workerInfo",
        JSON.stringify(result.worker)
      );

      // Save Session Data
      sessionStorage.setItem("phoneNumber", phoneNumber);
      sessionStorage.setItem(
        "workerName",
        result.worker.worker_name
      );

      // ✅ Save JWT Token
      sessionStorage.setItem("workerToken", result.token);

      console.log("✅ Token Saved:", result.token);

      alert(result.message || "Login successful");

      navigate("/ResumeOCR");

    } catch (err) {
      console.error("❌ Login Error:", err);

      setError(
        err?.response?.data?.message ||
        err.message ||
        "Login failed"
      );

    } finally {
      setLoading(false);
      console.log("🏁 Login Process Finished");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-top">
          <h1>Worker Login</h1>
          <p>Login using your mobile number</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          <div className="form-group">
            <label>Mobile Number</label>
            <input
              type="text"
              value={phoneNumber}
              onChange={handlePhoneChange}
              placeholder="Enter 10 digit mobile number"
              maxLength={10}
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;